var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st1{fill:#65ab65}.st2{fill:#de7c73}.st3{fill:#48b2d2}.st4{fill:#e79933}")), /*#__PURE__*/React.createElement("g", {
    id: "g6",
    transform: "translate(-124.34 -124.403) scale(1.41478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.06 203.22c14 6.3 24.8 15.3 32.4 27 7.6 11.7 11.4 25.45 11.4 41.25s-3.8 29.5-11.4 41.1c-7.6 11.6-18.4 20.55-32.4 26.85-14 6.3-30.5 9.45-49.5 9.45h-36.6v54.9h-59.4v-210h96c19 0 35.5 3.15 49.5 9.45zm-25.5 90.9c6.2-5.3 9.3-12.85 9.3-22.65 0-9.8-3.1-17.4-9.3-22.8-6.2-5.4-15.4-8.1-27.6-8.1h-33v61.5h33c12.2 0 21.4-2.65 27.6-7.95z",
    id: "path4",
    style: {
      fill: "gray"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.653 423.315c0 14.799-11.997 26.796-26.795 26.796-14.8 0-26.796-11.997-26.796-26.796",
    id: "path8",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.653 291.472c0-14.799-11.997-26.796-26.795-26.796-14.8 0-26.796 11.997-26.796 26.796",
    id: "path10",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 274.797,
    cy: 423.315,
    r: 26.796,
    id: "circle12",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 113.993,
    cy: 423.315,
    r: 26.796,
    id: "circle14",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 33.591,
    cy: 423.315,
    r: 26.796,
    id: "circle16",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    id: "rect18",
    style: {
      strokeWidth: 1.41478
    },
    d: "M167.047 290.368h53.606v134.546h-53.606z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.579 233.494c0-14.799-11.997-26.796-26.796-26.796s-26.796 11.997-26.796 26.796",
    id: "path20",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    id: "rect22",
    style: {
      strokeWidth: 1.41478
    },
    d: "M247.987 232.391h53.606v191.137h-53.606z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.817 346.195c0-14.798-11.997-26.796-26.795-26.796-14.8 0-26.796 11.998-26.796 26.796",
    id: "path24",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    id: "rect26",
    style: {
      strokeWidth: 1.41478
    },
    d: "M87.211 345.106h53.606v77.954H87.211z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.43 423.074c0-14.798-11.998-26.795-26.796-26.795-14.799 0-26.796 11.997-26.796 26.795",
    id: "path28",
    style: {
      strokeWidth: 1.41478
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    id: "rect30",
    style: {
      strokeWidth: 1.41478
    },
    d: "M6.824 421.971H60.43v1.556H6.824z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.877ba24b541d9d2853b31974a449ad10.svg";
export { ForwardRef as ReactComponent };